import { ReactNode } from 'react'

import { Asable } from '../../../../types/asable'
import * as Styled from './styles'

interface FormattedElementProps extends Asable {
  children: ReactNode
  asString?: boolean
}

export const FormattedElement = ({ as, children, asString }: FormattedElementProps): ReactNode => {
  return asString ? children : <Styled.FormattedElementWrapper as={as}>{children}</Styled.FormattedElementWrapper>
}
